import React from "react";
import im1 from "./Images/30k.jpeg";
import im2 from "./Images/15k.jpeg";
import im3 from "./Images/10k.jpeg";
import im4 from "./Images/5k.jpeg";

import "../styles/prizepool.css";

const Prizepool = () => {
  return (
    <>
      <div className="square-container">
        <img src={im1} alt="Your image description"></img>
      </div>

      <div className="c1">
        <div className="card-wrapper">
          {/* Card 1 */}
          <div className="c2">
            <div className="image-container">
              <img src={im2} alt="Card 1" />
            </div>
          </div>

          {/* Card 2 */}
          <div className="c2">
            <div className="image-container">
              <img src={im3} alt="Card 2" />
            </div>
          </div>

          {/* Card 3 */}
          <div className="c2">
            <div className="image-container">
              <img src={im4} alt="Card 3" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Prizepool;
